/**
 * The entry point.
 *
 * Three things happen before React: the fatal-error handler, because a bundle
 * that fails to boot on a kiosk with no browser chrome is a blank screen
 * nobody can diagnose; the theme, which follows the machine; and the touch
 * guards, which are properties of the window rather than of any screen and
 * have to hold while the boot screen is the only thing on the glass.
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app'
import { installTouchGuards } from './services/touch'
import { receiptFontReady } from './shell/receipt-font'
import './styles.css'

function fatal(message: string): void {
  const element = document.getElementById('app')
  if (element === null) return
  element.innerHTML = `
    <div style="display:flex;height:100vh;align-items:center;justify-content:center;background:#0b0b0c;color:#fff;font:16px system-ui;text-align:center">
      <div style="max-width:32rem;padding:2rem">
        <div style="font-size:1.5rem;font-weight:700;margin-bottom:1rem">MegaCoffee</div>
        <div style="opacity:.7">${message.replace(/[<>&]/g, '')}</div>
      </div>
    </div>`
}

window.addEventListener('error', (event) => {
  if (document.getElementById('app')?.childElementCount === 0) fatal(String(event.message))
})

installTouchGuards()
// Fetched now rather than at the first sale, so the service worker holds the
// receipt's face before a customer is waiting on it.
void receiptFontReady()

const element = document.getElementById('app')
if (element === null) {
  fatal('the application root is missing from index.html')
} else {
  createRoot(element).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
}
